<div class="container">
  <div class="form-container">
    <div class="header-container">
      <div class="button-container">
        <button  mat-raised-button color="accent" (click)="goBack()">
          <mat-icon>arrow_back</mat-icon>
        </button>
      </div>
      <h2>Simulação de Preço de Venda</h2>
    </div>

    <form [formGroup]="precoForm" class="preco-form">
      <div class="input-row" >
        <mat-form-field appearance="outline" class="flex-field">
          <mat-label>Produto</mat-label>
          <mat-select [formControl]="precoForm.controls['produto']" (selectionChange)="onSelectionChangeProduto($event)" required>
            <mat-option>
              <ngx-mat-select-search
                [formControl]="precoForm.controls['searchProduto']"
                placeholderLabel="Pesquisar Produto..."
                noEntriesFoundLabel="Produto não encontrado"
                [searching]="searching">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let produto of produtos" [value]="produto">
              <span>{{ produto?.codigo?.toString().padStart(5, '0') }}-</span>
              <span>{{ produto?.descricao?.trim() }}</span>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="precoForm.controls['produto'].hasError('required')">
            Produto é obrigatório.
          </mat-error>
        </mat-form-field>
        <div class="saldo-label">
          <label style="font-weight: bold; font-size: 1.5em;">Saldo: {{ saldo | number:'1.2-2' }}</label>
        </div>
      </div>
      
      <div class="input-row">
         <mat-form-field appearance="outline">
           <mat-label>Custo de Reposição</mat-label>
           <input matInput class="width" type="text" [formControl]="precoForm.controls['custoCompra']" currencyMask
             [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
         </mat-form-field>
         <mat-form-field appearance="outline">
           <mat-label>(%) Imposto S/Venda</mat-label>
           <input matInput class="width"  type="text" formControlName="impostoSVenda" currencyMask
             [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
           <span matSuffix>%</span>
         </mat-form-field>
         <mat-form-field appearance="outline">
           <mat-label>(%) Acréscimo Financeiro</mat-label>
           <input matInput class="width" type="text" formControlName="acrescimoFinanceiro" currencyMask
             [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
             <span matSuffix>%</span>
         </mat-form-field>
      </div>
        
        
        
      <div class="input-row">
        <mat-form-field appearance="outline">
          <mat-label>(%) Despesa Operacional</mat-label>
          <input matInput class="width" type="text" formControlName="despesaOperacional" currencyMask
            [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
            <span matSuffix>%</span>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>(%) Outros</mat-label>
          <input matInput class="width" type="text" formControlName="outros" currencyMask
            [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
            <span matSuffix>%</span>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>(%) Comissão</mat-label>
          <input matInput class="width" type="text" formControlName="comissao" currencyMask
            [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
            <span matSuffix>%</span>
        </mat-form-field>
      </div>

      <div class="totalizers-row">
        <mat-form-field appearance="outline" class="totalizer-field">
          <mat-label>(%) Entrar c/ Margem de Lucro S/ Preço de Venda</mat-label>
          <input matInput type="text" formControlName="lucrosSPreInput" currencyMask
            [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
            <span matSuffix>%</span>
        </mat-form-field>
        <mat-form-field appearance="outline" class="totalizer-field">
          <mat-label>Entrar c/ Valor do Lucro Desejado S/ Preço de Venda</mat-label>
          <input matInput type="text" formControlName="valorPrecoVendaInput" currencyMask
            [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
        </mat-form-field>
        <mat-form-field appearance="outline" class="totalizer-field">
          <mat-label>(%) Entrar c/ Margem de Lucro S/ o Custo</mat-label>
          <input matInput type="text" formControlName="lucrosSPrecoCustoInput" currencyMask
            [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
            <span matSuffix>%</span>
        </mat-form-field>
      </div>
      
      <div class="totalizers-row">
        <mat-form-field appearance="outline" class="totalizer-field">
          <mat-label>Entrar c/ Valor do Lucro Desejado S/ o Custo</mat-label>
          <input matInput type="text" formControlName="valorPrecoCustoInput" currencyMask
            [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
        </mat-form-field>
        <mat-form-field appearance="outline" class="totalizer-field">
          <mat-label>Preço de Venda Desejado</mat-label>
          <input matInput type="text" formControlName="precoVendaInput" currencyMask
            [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
        </mat-form-field>
        <mat-form-field appearance="outline" class="totalizer-field">
          <mat-label>Índice Desejado</mat-label>
          <input matInput type="text" formControlName="indiceInput" currencyMask
            [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }">
        </mat-form-field>
      </div>

      <div class="results-container">
        <h3>Total Encargos/Custos sobre a Venda</h3>
        <div class="totalizers-row">
          <mat-form-field appearance="outline" class="totalizer-field">
            <mat-label>(%)Total Encargos</mat-label>
            <input matInput type="text" [value]="totalEncargos | number:'1.2-2'" readonly>
            <span matSuffix>%</span>
          </mat-form-field>
          <mat-form-field appearance="outline" class="totalizer-field">
            <mat-label>Valor Total Encargo</mat-label>
            <input matInput type="text" [value]="valorEncargo | number:'1.2-2'" readonly>
          </mat-form-field>
          <mat-form-field appearance="outline" class="totalizer-field">
            <mat-label>(%) Encargos/Custo equivalente Preço Venda</mat-label>
            <input matInput type="text" [value]="totalCustoVenda | number:'1.2-2'" readonly>
            <span matSuffix>%</span>
          </mat-form-field>
          <mat-form-field appearance="outline" class="totalizer-field">
            <mat-label>Custo Total com Encargos</mat-label>
            <input matInput type="text" [value]="valorCustoVenda | number:'1.2-2'" readonly>
          </mat-form-field>
        </div>
      </div>

      <div class="results-container">
        <h3>Resultado da Simulação</h3>
        <div class="totalizers-row">
          <mat-form-field appearance="outline" class="totalizer-field">
            <mat-label>(%) Lucro S/Preço Venda</mat-label>
            <input matInput type="text" [value]="lucrosSPrecoVenda | number:'1.2-2'" readonly>
            <span matSuffix>%</span>
          </mat-form-field>
          <mat-form-field appearance="outline" class="totalizer-field">
            <mat-label>Valor Lucro Líquido S/ Preço Venda</mat-label>
            <input matInput type="text" [value]="valorPrecoVenda | number:'1.2-2'" readonly>
          </mat-form-field>
          <mat-form-field appearance="outline" class="totalizer-field">
            <mat-label>(%) Lucro S/Preço Custo</mat-label>
            <input matInput type="text" [value]="lucrosSPrecoCusto | number:'1.2-2'" readonly>
            <span matSuffix>%</span>
          </mat-form-field>
          <mat-form-field appearance="outline" class="totalizer-field">
            <mat-label>Valor Lucro S/ Preço Custo</mat-label>
            <input matInput type="text" [value]="valorPrecoCusto | number:'1.2-2'" readonly>
          </mat-form-field>
        </div>

        <div class="totalizers-row">
        </div>

        <div class="totalizers-row">
          <mat-form-field appearance="outline" class="totalizer-field">
            <mat-label>Preço Venda Sugerido</mat-label>
            <input matInput type="text" [value]="precoVenda | number:'1.2-2'" readonly>
          </mat-form-field>
          <mat-form-field appearance="outline" class="totalizer-field">
            <mat-label>Índice Calculado</mat-label>
            <input matInput type="text" [value]="indiceCalc | number:'1.2-2'" readonly>
          </mat-form-field>
          <mat-form-field appearance="outline" class="totalizer-field">
            <mat-label>Preço Venda Atual(Praticado)</mat-label>
            <input matInput type="text" [value]="precoVendaAtual | number:'1.2-2'" readonly>
          </mat-form-field>
          <div class="totalizer-field">
            <button mat-raised-button color="primary" (click)="gravarPrecoVendaSugerido()">
              Gravar Preço Venda Sugerido
            </button>
          </div>
        </div>

        <div class="totalizers-row">
        </div>
      </div>
    </form>
  </div>
</div>